import React from 'react';
import { ErrorListItem } from '../../../molecules/ErrorListItem/ErrorListItem';
import { EmailField } from '../../../molecules/input/EmailField/EmailField';
import { PasswordField } from '../../../molecules/input/PasswordField/PasswordField';

function StepOne({
    handleInputChange,
    handleInputBlur,
    forgotPasswordData,
    clientSideErrors,
    clientSideTouched,
    serverSideErrors,
    isLoading,
    autoFocus,
    resourcedTexts,
}) {
    return (
        <div className="login-one">
            <div className="row">
                <div className="col-12 col-lg-6">
                    <EmailField
                        name="email"
                        labelText={resourcedTexts.emailLabel}
                        required
                        autoFocus={autoFocus}
                        handleInputChange={handleInputChange}
                        handleInputBlur={handleInputBlur}
                    />
                </div>

                <div className="col-12 col-lg-6">
                    <PasswordField
                        name="password"
                        labelText={resourcedTexts.passwordLabel}
                        required
                        handleInputChange={handleInputChange}
                        handleInputBlur={handleInputBlur}
                    />
                </div>
            </div>

            <ul className="login-one__errors">
                {Object.entries(clientSideErrors).map(([key, value]) => {
                    const isTouched = clientSideTouched[key];
                    if (!isTouched || !value) return null;
                    return <ErrorListItem key={key}>{value}</ErrorListItem>;
                })}

                {serverSideErrors.map((error) => {
                    if (!error) return null;
                    return <ErrorListItem key={error}>{error}</ErrorListItem>;
                })}
            </ul>

            <a className="login-one__password-link" href={forgotPasswordData.href}>
                {forgotPasswordData.title}
            </a>

            <button className="login-one__button button primary" disabled={isLoading}>
                {isLoading ? resourcedTexts.loadingButton : resourcedTexts.loginButton}
            </button>
        </div>
    );
}

export { StepOne };
